import CONSTANTS from "./constants";

export const submitLeadCapture = (payload) => {
  return {
    type: CONSTANTS.SUBMIT_LEAD_DATA,
    payload,
  };
};
